// @flow

import type { ReopenJobOperation } from '../types'

export default ({
  operations: [],
}: {
  operations: Array<ReopenJobOperation>,
})
